import { createContext } from "react";

import type { RootStore } from "@state/stores/types";

export const RootAppStoreContext = createContext<RootStore>(
	App?.state?.rootStore
);
